import type { Task } from '../types';

export interface GetTaskListRequest {
    page: number;
    limit: number;
    type: 'AI_TRANSLATION' | 'AI_PATENT_DISCLOSURE' | 'AI_SPECIFICATION' | 'AI_NOVELTY_SEARCH' | 'AI_FTO_SEARCH' | 'AI_NEW_FTO_SEARCH' | 'AI_OAR' | 'ALL';
}

export type TaskStatus = 'Ready' | 'Running' | 'Complete' | 'Failed';

export interface GetTaskListResponse {
    total: number;
    page: number;
    limit: number;
    total_page: number;
    list: {
        task_id: string;
        title: string;
        read: boolean;
        created_at: number;
        updated_at: number;
        task_type: 'SYNC' | 'ASYNC';
        task_status: TaskStatus;
        type: GetTaskListRequest['type'];
    }[];
}

export const TaskApi = Symbol('TaskApi');

export interface TaskApi {
    getTaskList(data: GetTaskListRequest): Promise<GetTaskListResponse>;
    getTaskDetail(taskId: string): Promise<Task>;
    cancelTask(taskId: string): Promise<void>;
}
